import * as actions from "./actions";
import { Map } from "immutable";
import { Record } from "../transit";
import { ValidationError } from "../lib/validation";
import Alert from "react-s-alert";

import { hashFromObj } from "../lib/utils/hash";

import { normalize, Schema, arrayOf } from "normalizr";

const agency = new Schema("agencies", { idAttribute: "uid" });

const State = Record(
  {
    map: Map(),
    results: Map(),
    meta: new (Record(
      {
        currentPage: 1,
        limit: 15,
        offset: 0,
        sortDir: "desc",
        sortField: "createdAt",
        search: new (Record(
          {
            name: ""
          },
          "search"
        ))()
      },
      "meta"
    ))(),
    deleteStatus: 0,
    form: new (Record(
      {
        loading: false,
        fileLoading: false,
        filePreview: null,
        error: null
      },
      "form"
    ))()
  },
  "agency"
);

const agenciesReducer = (state = new State(), action) => {
  switch (action.type) {
    case actions.CREATE_AGENCY: {
      return state.setIn(["form", "loading"], true);
    }

    case actions.CREATE_AGENCY_SUCCESS: {
      Alert.success("Dodano agencję", {
        position: "bottom-right",
        timeout: 3000
      });
      return state.setIn(["form", "loading"], false);
    }

    case actions.CREATE_AGENCY_ERROR: {
      const { errors, data } = action.payload;
      return state
        .setIn(["form", "error"], errors)
        .setIn(["form", "loading"], false);
    }

    case actions.CREATE_AGENCY_FINALLY: {
      return state.setIn(["form", "loading"], false);
    }

    case actions.UPDATE_AGENCY: {
      return state.setIn(["form", "loading"], true);
    }

    case actions.UPDATE_AGENCY_SUCCESS: {
      const { data } = action.payload;
      return state.setIn(["form", "loading"], false);
    }

    case actions.UPDATE_AGENCY_ERROR: {
      const { errors, data } = action.payload;
      return state
        .setIn(["form", "error"], errors)
        .setIn(["form", "loading"], false);
    }

    case actions.UPDATE_AGENCY_FINALLY: {
      return state.setIn(["form", "loading"], false);
    }

    case actions.CREATE_AGENCY_LOGO: {
      return state.setIn(["form", "fileLoading"], true);
    }

    case actions.CREATE_AGENCY_LOGO_SUCCESS: {
      const { data } = action.payload;
      return state
        .setIn(["form", "fileLoading"], false)
        .setIn(["form", "filePreview"], data.get("file").preview);
    }

    case actions.CREATE_AGENCY_LOGO_ERROR: {
      const { errors, data } = action.payload;
      return state
        .setIn(["form", "error"], errors)
        .setIn(["form", "fileLoading"], false);
    }

    case actions.CREATE_AGENCY_LOGO_FINALLY: {
      return state.setIn(["form", "fileLoading"], false);
    }

    case actions.GET_AGENCIES_SUCCESS: {
      const { body, data } = action.payload;
      const nrs = normalize(body, { agencies: arrayOf(agency) });
      return state
        .update("map", map => map.merge(nrs.entities.agencies))
        .update("results", rs => rs.set(hashFromObj(data), nrs.result));
    }

    case actions.GET_AGENCY_SUCCESS: {
      const { body, data } = action.payload;
      const nrs = normalize(body, agency);
      return state.update("map", map => map.merge(nrs.entities.agencies));
    }

    case actions.DELETE_AGENCY: {
      return state.setIn(["deleteStatus"], 1);
    }

    case actions.DELETE_AGENCY_SUCCESS: {
      return state.setIn(["deleteStatus"], 2);
    }

    case actions.DELETE_AGENCY_ERROR: {
      return state.setIn(["deleteStatus"], 3);
    }

    case actions.SET_DELETE_STATUS: {
      const { status } = action.payload;
      return state.setIn(["deleteStatus"], status);
    }

    case actions.SET_AGENCY_PAGE: {
      const { page } = action.payload;
      const limit = state.getIn(["meta", "limit"]);
      return state
        .setIn(["meta", "currentPage"], page)
        .setIn(["meta", "offset"], (page - 1) * limit);
    }

    case actions.SET_AGENCY_SORT: {
      const { field, dir } = action.payload;
      return state
        .setIn(["meta", "sortDir"], dir)
        .setIn(["meta", "sortField"], field);
    }

    case actions.SET_AGENCY_SEARCH_FIELD: {
      const { field, value } = action.payload;
      return state.setIn(["meta", "search", field], value);
    }

    case actions.AGENCY_CLEAR_ERROR: {
      const { field } = action.payload;

      let errors =
        state.form.error && state.form.error && state.form.error.errors;
      if (errors && errors[field]) {
        errors[field] = undefined;
      }

      return state.setIn(["form", "error"], new ValidationError(errors));
    }

    case actions.AGENCY_CLEAR_FORM: {
      return state
        .setIn(["form", "error"], null)
        .setIn(["form", "filePreview"], null);
    }

    case actions.AGENCY_CLEAR_FORM_PREVIEW: {
      return state.setIn(["form", "filePreview"], null);
    }

    default:
      return state;
  }
};

export default agenciesReducer;



// WEBPACK FOOTER //
// ./src/common/agency/reducer.js